import { connect } from 'react-redux';
import Work from './work';
import { loadWorkDetails } from '../../actions/works';
import { removeFromCanvas } from '../../actions/canvas';

const mapStateToProps = ({ workDetails }, { workId }) => workDetails[workId] || {};

export default connect(mapStateToProps, { loadWorkDetails, removeFromCanvas })(Work);
